/**
 * Brushed-metal highlight along the top edge of a field.
 *
 * A border can't produce this — it would be one flat colour — so it's a 1px
 * element painted over the control, brightest mid-span and fading out at both
 * ends. Inset by the corner radius so it stops before the rounded corners
 * rather than curving down them, and z-10 to sit above controls that create
 * their own paint context (e.g. a button).
 *
 * Requires a `relative` parent.
 */
export function TopSheen() {
  return (
    <span
      aria-hidden
      className="pointer-events-none absolute left-2 right-2 top-0 z-10 h-px bg-gradient-to-r from-white/5 via-white/70 to-white/5"
    />
  );
}
